import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'label-divider';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'div', { class: ['label-divider__wrapper', ctx.data.staticClass] }, [
                h('span', { class: 'label-divider__label wok--body-short-02' }, [
                    ctx.slots().default
                ]),
                h('hr', { class: 'label-divider__divider' })
            ]
        )
    }
}